import { Toolbar, SaveButton } from "react-admin";

export const SaveAction = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton {...props} type="button" />
    </Toolbar>
  );
};
